/* MXIRO UI helpers: smooth open/close for dialogs (size chart modal, product detail panels) */
(function () {
  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  function closeDialog(dialog, instant) {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    if (instant || reduceMotion()) {
      dialog.close();
      return;
    }
    dialog.classList.add('is-closing');
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      dialog.classList.remove('is-closing');
      dialog.close();
    };
    dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 600);
  }

  function openDialog(id, from) {
    var dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var current = from && from.closest ? from.closest('dialog[open]') : null;

    if (!dialog.open) dialog.showModal();

    // Switching between panels: the new one slides up over the old one, then the old one is removed.
    if (current && current !== dialog) {
      setTimeout(function () {
        current.close();
      }, reduceMotion() ? 0 : 520);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opener = target.closest('[data-mx-open]');
    if (opener) {
      event.preventDefault();
      openDialog(opener.getAttribute('data-mx-open'), opener);
      return;
    }

    var closer = target.closest('[data-mx-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }

    // Click on the backdrop closes the dialog
    if (target instanceof HTMLDialogElement && target.classList.contains('mx-dialog') && target.open) {
      closeDialog(target);
    }
  });

  // Escape key: close with the same animation
  document.addEventListener(
    'cancel',
    function (event) {
      var dialog = event.target;
      if (dialog instanceof HTMLDialogElement && dialog.classList.contains('mx-dialog')) {
        event.preventDefault();
        closeDialog(dialog);
      }
    },
    true
  );
})();
